import { useEffect, useState } from "react"

import picCalendar from '../../images/calendar.svg'
import picWater from '../../images/water.svg'
import picRain from '../../images/rain.svg'

import { getEVentFilterDate, getEventFilterName, getLocaleDate, getWaterStateSVG, isActiveFilterItem, loadEventFiltered, loadEventSituation, showEventDate, showEventDateTime, showEventFilteredValue } from "./utils";
import References from "../../helpers/Reference";
import { InfoCircleOutlined, LeftCircleOutlined, QuestionCircleOutlined, QuestionOutlined, RightCircleOutlined, TableOutlined } from "@ant-design/icons";
import { findInJSONArray, getDangerBGColor, getDangerColor, getDangerShortName } from "../../helpers/helpers";
import { EventIntegral } from "./event.integral";
import { Popover } from "antd";
import dayjs from 'dayjs';

import { HelperContext } from "../Helper/helper.context";

import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { helpContextResponsive } from "../Helper/utils";

import ImgScreen1 from '../../images/help_context/feed_1.png';
import ImgScreen2 from '../../images/help_context/feed_2.png';
import ImgScreen3 from '../../images/help_context/feed_3.png';
import ImgScreen4 from '../../images/help_context/feed_4.png';



const EVENT_SITUATION_VIEW_SHORT = 'short';

const SUMMARY_START_DATE = new Date().getTime() - 1000 * 60 * 60 * 24 * 7;
const SUMMARY_FINISH_DATE = new Date().getTime();  

const EVENT_REFRESH_INTERVAL = 60;   //in seconds

export const EventSituation = ({isLoadingActual, actual, onShowChartWindow}) => {

    const [ eventSummary, setEventSummary ] = useState([]);

    const [ eventFilter, setEventFilter] = useState({})
    const [ isShowEventFilterted, setIsShowEventFiltered] = useState(false);
    const [ eventFiltered, setEventFiltered ] = useState([]);

    const [isShowEventIntegral, setIsShowEventIntegral] = useState(false);

    const [ loaded, setLoaded ] = useState( false );    
    const [ view, setView ] = useState(EVENT_SITUATION_VIEW_SHORT);

    const [timerEventsSummary, setTimerEventsSummary] = useState(null);
    const [timerEventsFiltered, setTimerEventsFiltered] = useState(null);

    const [isShowHelperContext, setIsShowHelperContext] = useState(false);

    const updateEventSituation = (finish, loaded) => {
        return loadEventSituation( finish, loaded )
        .then(data => {
            setLoaded(true);
            setEventSummary(data);
        }).catch(() => console.log('not_json'));        
    }

    const updateEventFiltered = (start, finish, filter) => {
        return loadEventFiltered(start, finish, filter)
        .then(data => {
            setEventFiltered(data)
        });
    }

    useEffect(()  => {
        if (isLoadingActual) {
            
            updateEventSituation(            
                getLocaleDate(),
                loaded
            );
            setTimerEventsSummary(
                setInterval(
                    updateEventSituation, 
                    EVENT_REFRESH_INTERVAL * 1000, 
                    getLocaleDate()
                )
            );
            return clearInterval(timerEventsSummary);
        }
    }, [isLoadingActual])

    const handleChangeView = () => {
        setView(view === EVENT_SITUATION_VIEW_SHORT ? null : EVENT_SITUATION_VIEW_SHORT)
    }

    const handleShowHelper = () => {
        setIsShowHelperContext(true);
    }

    const handleClearEventFilterClick = () => {
        setEventFilter([]);
        setEventFiltered([]);
        setIsShowEventFiltered(false);

    }

    const handleEventFilterClick = (filter, id, name) => {
        let currFilter = eventFilter;

        if (currFilter.hasOwnProperty(filter) && currFilter[filter].id === id)
            delete currFilter[filter];
        else {
            currFilter = {};
            currFilter[filter]= {
                    id: id,
                    name: name
            };
        }
        const isNeedUpdate = Object.keys(currFilter).length > 0;

        if (isNeedUpdate) {
            const start = getLocaleDate(1000 * 3600 * 24 * 7 * -1);
            const finish = getLocaleDate();
            updateEventFiltered(start, finish, currFilter)

            //обновление            
            if (timerEventsFiltered) 
                clearInterval(timerEventsFiltered);

            setTimerEventsFiltered(
                setInterval(
                    updateEventFiltered,                     
                    EVENT_REFRESH_INTERVAL * 1000,
                    start, finish, currFilter
                )
            );
        }
     
        setEventFilter(currFilter)
        setIsShowEventFiltered(isNeedUpdate);
    }

    const handleEventFilterClose = () => {
        clearInterval(timerEventsFiltered);
        setTimerEventsFiltered(null);                        
        setEventFiltered([]);
        setEventFilter([]);
        setIsShowEventFiltered(false);        
    }

    const handleEventFilteredClick = (stationUUID, mch, start, finish) => {
        const mchUUID = mch?.mch_main ? mch.mch_main : mch.uuid;
        const station = findInJSONArray(actual, 'uuid', stationUUID);
        //период в подробном окне считается от переданной начальной даты -1 день. Надо передать на день вперед
        onShowChartWindow(
            station, mchUUID, null, 
            dayjs(start).startOf('day').toDate(),
            dayjs(finish).add(1, 'day').startOf('day').toDate()
        );
    }

    const handleEventShowIntegral = () => {
        setIsShowEventIntegral(true);
    }

    const onCloseIntegral = () => {
        setIsShowEventIntegral(false);
    }

    const onCloseHelperContext = () => {
        setIsShowHelperContext(false);
    }

    return <>
        {isShowEventIntegral && 
            <EventIntegral onClose={onCloseIntegral} />
        }


        {isShowHelperContext && 
        <HelperContext 
            onClose={onCloseHelperContext}
            children={
                <div className="help-context-wrapper">
                    <Carousel 
                        className="help-context-carousel"
                        responsive={helpContextResponsive}
                    >
                        <div className="help-context-item">
                            <img src={ImgScreen1}/>
                        </div>
                        <div className="help-context-item">
                            <img src={ImgScreen2}/>
                        </div>
                        <div className="help-context-item">
                            <img src={ImgScreen3}/>
                        </div>
                        <div className="help-context-item">
                            <img src={ImgScreen4}/>
                        </div>

                    </Carousel>
                </div>
            }
        />
        }

        <div id="event-situation">
            <div>
                {isShowEventFilterted &&
                    <div className="event-situation-filtered">
                        <div className="event-filtered-header border-l-4">
                            <span className="close" onClick={handleEventFilterClose}>&times;</span>
                            <div>{References.dictionary.filter_events.date}: {getEventFilterName(eventFilter, 'date')}</div>
                            <div>{References.dictionary.filter_events.mch}: {getEventFilterName(eventFilter, 'mch')}</div>
                            <div>{References.dictionary.filter_events.station}: {getEventFilterName(eventFilter, 'station')}</div>
                        </div>
                        <div className="event-filtered-body">
                            {eventFiltered?.events?.map(data => {
                                const criteria = data.mch?.criteria
                                return (
                                    <div className="border-l-4 event-filter-body-item" style={{
                                        borderLeftColor: getDangerColor(data.danger_level_code),
                                        backgroundColor: getDangerBGColor(data.danger_level_code)                                        
                                        }}
                                        key={`event-filtered-item-${data.uuid}`}
                                        onClick={() => handleEventFilteredClick(data.station.uuid, data.mch, data.time, getEVentFilterDate(eventFilter))}
                                    >
                                        <div className="event-filtered-ico">
                                            <Popover content={criteria && References.event.criteria_field.hasOwnProperty(criteria) ? References.event.criteria_field[criteria].name : null}>
                                            <img src={getWaterStateSVG(data.danger_level_code, data?.mch?.type)}/>
                                            
                                            {References.event.criteria_field.hasOwnProperty(criteria) && References.event.criteria_field[criteria]?.short_name &&
                                            <div className="event-filtered-ico-badge" style={{backgroundColor: getDangerColor(data.danger_level_code, {[References.dangers.unknown]: "rgb(170, 170, 170)"})}}>
                                                {References.event.criteria_field[criteria].short_name}
                                            </div>
                                            }
                                            </Popover>
                                        </div>
                                        <div className="ml-2">
                                            <div><span className="text-small">{showEventDateTime(data.time)}</span><span className="ml-4 b">{data.station.name}</span></div>
                                            <div className="b" style={{
                                                color: getDangerColor(data.danger_level_code, {[References.dangers.unknown]: "rgb(170, 170, 170)"}),
                                            }}
                                            >
                                                {getDangerShortName(data.danger_level_code_from).toUpperCase()} &rarr; {getDangerShortName(data.danger_level_code).toUpperCase()} ({showEventFilteredValue(data?.mch)})
                                            </div>
                                        </div>
                                    </div>        
                                )
                            })}
                        </div>
                    </div> 
                }

                {loaded &&
                <div className="event-situation-list position-relative">
                    <div className="event-situation-footer" onClick={handleChangeView}><div>
                        {view === EVENT_SITUATION_VIEW_SHORT ?
                            <><LeftCircleOutlined /></> : <><RightCircleOutlined /></>
                        }
                    </div></div>

                    <div onClick={handleShowHelper} style={{position: "absolute", right: "0", top: "0", color: "#fff", fontSize: "14px", cursor: "pointer"}} >
                        <QuestionCircleOutlined />
                    </div>


                    <div className="event-sutiation-header event-situation-row">
                        <div>
                            <img 
                                onClick={() => handleClearEventFilterClick()} 
                                src={picCalendar}
                                className="cursor-pointer"
                            />
                        </div>
                        {view !== EVENT_SITUATION_VIEW_SHORT &&
                        <>
                            <div className={isActiveFilterItem('event_type', {mch: References.mchs.waterlevel.callbackname}, eventFilter) ? 'filtered' : null}>
                            <img
                                onClick={() => handleEventFilterClick('event_type', {mch: References.mchs.waterlevel.callbackname}, {mch: References.mchs.waterlevel.name})}                                 
                                src={picWater}
                                className="cursor-pointer"
                            />
                            </div>

                            <div className={isActiveFilterItem('event_type', {mch: 'precipitation'}, eventFilter) ? 'filtered' : null}>
                            <img 
                                onClick={() => handleEventFilterClick('event_type', {mch: 'precipitation'}, {mch: References.mchs.precipitation.name})} 
                                src={picRain}
                                className="cursor-pointer"
                            />
                            </div>                            
                        </>
                        }

                    </div>

                    <div className="event-situation-body">
                    {Object.keys(eventSummary).map(date => { 
                        return (
                        <div key={`summary-date-${date}`}>
                            <div key={`date-header-${date}`} className="event-situation-row-header"> 
                                <div className="event-situation-row">
                                    <div 
                                        onClick={() => handleEventFilterClick('date', {date: date}, {date: showEventDate(date)})}
                                        className={`cursor-pointer ${isActiveFilterItem('date', {date: date}, eventFilter) ? 'filtered' : null}`}
                                    >{showEventDate(date)}</div>
                                    {view !== EVENT_SITUATION_VIEW_SHORT &&
                                    <>
                                    {References.event.situation.map(mchs => {
                                        const score = eventSummary[date]?.summary?.mchs[mchs]?.score;                                        
                                        return (                                            
                                            <div 
                                                key={`ess-${date}-${mchs}`}
                                                className={`cursor-pointer event-situation-scores ${isActiveFilterItem('score', {mch: mchs, date: date}, eventFilter) ? 'filtered' : null}`}
                                                onClick={() => {handleEventFilterClick('score', {mch: mchs, date: date}, {date: showEventDate(date), mch: References?.mchs[mchs]?.name})}}
                                            >
                                                {!score ? (
                                                        <div>&times;</div>                                
                                                ) : (    
                                                Object.keys(score).reverse().map(key  => {
                                                    return <div key={`ess-${date}-${mchs}-${key}`} className={`state-background_${key}`}>{score[key]}</div>
                                                }))
                        
                                            }</div>
                                        )
                                    })}
                                    </>
                                    }

                                </div>
                            </div>
                            {Object.keys(eventSummary[date]).length > 0 && 
                                <div className="event-situation-row-body">
                                    {Object.keys(eventSummary[date]?.stations).map(stationKey => {
                                        const station = eventSummary[date]?.stations[stationKey];
                                        return (
                                        <div key={`event-situation-station-${stationKey}`} className="event-situation-row">
                                            <div className={isActiveFilterItem('station', {station: stationKey, date: date}, eventFilter) ? "filtered" : null}>
                                                <div 
                                                    className={`marker-big text-shadow marker-content cursor-pointer pos-relative state-background_${station?.state?.level_code}`} 
                                                    onClick={() => handleEventFilterClick('station', {station: stationKey, date: date}, {station: station.name, date: showEventDate(date)})}
                                                >
                                                            {station.short_name}
                                                            {station?.state?.level_code_highest &&
                                                                <div className={`highest-level-code-badge state-background_${station.state.level_code_highest}`}>&nbsp;</div>
                                                            }
                                                </div>
                                            </div>
                                            {view !== EVENT_SITUATION_VIEW_SHORT &&
                                            <>

                                            {References.event.situation.map(mchs => {
                                                const score = station.mchs[mchs]?.score;
                                                return (                                    
                                                    <div 
                                                        key={`essl-${stationKey}-${mchs}`}
                                                        className={`cursor-pointer event-situation-scores  ${isActiveFilterItem('score', {station: stationKey, mch: mchs, date: date}, eventFilter) ? 'filtered' : null}`}
                                                        onClick={() => {handleEventFilterClick('score', {station: stationKey, mch: mchs, date: date}, {station: station.name, mch: References.mchs[mchs].name, date: showEventDate(date)})}}
                                                    >
                                                        {!score ? (
                                                            <div>&times;</div>                                
                                                        ) : (    
                                                        Object.keys(score).reverse().map(key  => {
                                                            return <div key={`essl-${stationKey}-${mchs}-${key}`}className={`state-background_${key}`}>{score[key]}</div>
                                                        }))}
                                                    </div>
                                                )
                                            })}
                                            </>
                                            }
                                            
                                        </div>
                                        )
                                    })}
                                </div>
                            }        
                        </div>
                    )
                    })}                
                    </div>

                    <div className="event-situation-row event-show-integral" onClick={handleEventShowIntegral}><div>
                        <Popover 
                            content={References.dictionary.event_situation_table}
                        >
                        <TableOutlined />
                        </Popover>
                    </div></div>
                </div>
                }
            </div>

        </div>
    </>
} 